import { getEnabledOnlinePaymentTypes } from '@commons/config/onlinePaymentTypesEnabledPerCountry';

const apiGatewayUrl = '';

export const createEndpointURL = endpoint => `${apiGatewayUrl}${endpoint}`;

export const paymentMethods = countryShortName =>
  getEnabledOnlinePaymentTypes(countryShortName).join();
